// ============================================
// ORDERS CHART - Line chart for orders by month
// ============================================

import { Chart } from 'chart.js';

export interface OrdersChartData {
    labels: string[];
    data: number[];
}

let chartInstance: Chart | null = null;

export async function initOrdersChart(chartData: OrdersChartData): Promise<void> {
    const canvas = document.getElementById('ordersChart') as HTMLCanvasElement;
    if (!canvas) {
        console.error('Canvas ordersChart not found');
        return;
    }

    if (!chartData || !chartData.labels || !chartData.data) {
        console.error('Invalid chart data:', chartData);
        throw new Error('Invalid chart data');
    }

    // Destroy existing chart instance if it exists
    if (chartInstance) {
        chartInstance.destroy();
        chartInstance = null;
    }

    // Get CSS variables from computed styles
    const styles = getComputedStyle(document.documentElement);
    const whiteColor = styles.getPropertyValue('--bs-primary').trim() || '#ffffff';

    try {
        // Create mini sparkline chart
        chartInstance = new Chart(canvas, {
            type: 'line',
            data: {
                labels: chartData.labels,
                datasets: [{
                    data: chartData.data,
                    borderColor: whiteColor,
                    backgroundColor: `${whiteColor}33`,
                    tension: 0.4,
                    fill: true,
                    pointRadius: 3,
                    pointHoverRadius: 6,
                    pointBackgroundColor: whiteColor,
                    borderWidth: 2,
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                interaction: {
                    intersect: false,
                    mode: 'index'
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        enabled: true,
                        backgroundColor: 'rgba(0, 0, 0, 0.8)',
                        padding: 8,
                        titleColor: '#fff',
                        bodyColor: '#fff',
                        displayColors: false,
                        titleFont: {
                            size: 11
                        },
                        bodyFont: {
                            size: 11
                        },
                        callbacks: {
                            title: function(context) {
                                return context[0].label;
                            },
                            label: function(context) {
                                return `${context.parsed.y} orders`;
                            }
                        }
                    }
                },
                scales: {
                    y: {
                        display: false,
                        beginAtZero: true
                    },
                    x: {
                        display: false
                    }
                }
            }
        });

    } catch (error) {
        console.error('Error loading orders chart:', error);
        throw error;
    }
}
